<!--
* @Name：采购订单申请页面
* @Author: 王超
* @Date: 2022-03-09
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="采购申请审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">采购申请基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="materialDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">物料信息明细</span>
        </template>
        <material-details :currencyDict="headInfo.currencyDict" todo-name="PoApproval" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { coopPrCreateHead } from '@/api/purchaseRequest'
import Bridge from '@/components/dsbridge'
export default {
  name: 'PrApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'material-details': () => import('./components/MaterialDetails.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      // 主单信息
      headInfo: {},
      // 附件列表
      attachList: [],
      // 审批单ID
      // prCreateHeadId: this.$store.getters.businessKey
      prCreateHeadId: this.$route.query.businessKey
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    // 获取采购申请主单信息和附件列表
    async initData() {
      const headResp = await coopPrCreateHead(this.prCreateHeadId)
      this.headInfo = headResp.data
      this.attachList = this.headInfo.uploadIconType
    },
    // 返回到审批待办列表
    onClickLeft() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
